export const livestockTypes = [
  {
    label: 'Single',
    value: 'single',
  },
  {
    label: 'Group',
    value: 'group',
  },
]